var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './historicMovedApplicationView.html';
import './historicMovedApplication.scss';
import { IRootScopeService, translate } from 'angular';
import * as angular from 'angular';
import { IStateService } from 'angular-ui-router';
import { ItemsInHeader, ListApplicationsAccount } from 'modules/shared/ApplicationTypings';
import { ApplicationService2 } from 'modules/application/ApplicationService2';
import { ContextProcessorService } from 'modules/core/ContextProcessorService';
import { AccountService2 } from 'modules/account/AccountService2';
import { TenantRoles, TenantService } from 'modules/application/tenant/TenantService';
import { LoadingService } from 'modules/ui/LoadingService';
import foldToASCII from 'data/foldToASCII';
import { SegmentService } from 'modules/application/misc/SegmentService';
import { ORGANIZATION_CHATBOTS_SEARCH } from 'modules/application/tenant/TenantSegmentEvents';
const OnSeachEvent = 'OnSeachEvent';
const MASTER = 'master';
const BUILDER = 'builder';
let HistoricMovedApplicationComponent = class HistoricMovedApplicationComponent {
    static $inject = ['$state', '$rootScope', '$translate', '$window', '$location', 'ContextProcessorService', 'ApplicationService2', 'TenantService', 'AccountService2', 'LoadingService', 'SegmentService', 'BLIP_DOMAIN'];
    constructor($state, $rootScope, $translate, $window, $location, ContextProcessorService, ApplicationService2, TenantService, AccountService2, LoadingService, SegmentService, BLIP_DOMAIN) {
        'ngInject';
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$window = $window;
        this.$location = $location;
        this.ContextProcessorService = ContextProcessorService;
        this.ApplicationService2 = ApplicationService2;
        this.TenantService = TenantService;
        this.AccountService2 = AccountService2;
        this.LoadingService = LoadingService;
        this.SegmentService = SegmentService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.isMoving = true;
        this.viewHistoricDetail = {};
        this.noSearchResults = false;
        this.$rootScope.$on(OnSeachEvent, (_, text) => this.onSearchBots(text));
        this.onInit();
    }
    async onInit() {
        this.LoadingService.startLoading(false);
        try {
            await this.ContextProcessorService.waitForInitialization();
            if (this.$window.location.pathname == '/application/historic') {
                const currentTenantId = this.TenantService.getTenantPrefixFromUrl();
                const isTenantAdmin = await this.TenantService.currentUserHasRequiredTenantRole(currentTenantId, [TenantRoles.Admin]);
                this.historic = await this.getHistoric(currentTenantId, isTenantAdmin);
                this.isMoving = false;
            }
            this.historic?.forEach(async (e) => {
                e.User = await this.getUser(e.UserIdentity);
            });
            await this.flowCheckedRouter();
            const indexsOfMigraton = await this.getHistoricIndices(this.historic);
            this.viewHistoricDetail = await this.createIndexOfList(indexsOfMigraton);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    view(index) {
        return this.viewHistoricDetail[index];
    }
    async getHistoric(tenantId, isAdm) {
        if (isAdm) {
            return this.ApplicationService2.getHistoricApplications(tenantId);
        }
        else {
            const user = await this.AccountService2.me();
            const userIdentity = encodeURIComponent(`${user.email}`);
            return this.ApplicationService2.getHistoricApplications(tenantId, undefined, userIdentity);
        }
    }
    async getUser(userIdentify) {
        return await this.AccountService2.get(encodeURIComponent(userIdentify));
    }
    async createIndexOfList(indexsOfMigraton) {
        return this.historic.map((_, index) => indexsOfMigraton.indexOf(index) > -1);
    }
    async getHistoricIndices(historic) {
        return historic.reduce((indices, current, currentIndex) => {
            if (current.Applications) {
                indices.push(currentIndex);
            }
            return indices;
        }, []);
    }
    createListHistoricInExhibition(index) {
        this.viewHistoricDetail[index] = !this.viewHistoricDetail[index];
    }
    async flowCheckedRouter() {
        this.historic?.forEach(i => {
            i.lengthTotal = i.Applications.items.length;
            i.ListApplicationsAccount = new ListApplicationsAccount();
            i.ListApplicationsAccount.itemsInHeader = [];
            i.Applications.items.forEach(async (item) => {
                if (item.template !== MASTER) {
                    return;
                }
                const children = await this.getChildren(item.shortName, i.DestinationTenantId);
                if (children !== undefined) {
                    item.blocked = false;
                    const newList = new ItemsInHeader();
                    newList.id = item.shortName;
                    newList.name = item.name;
                    newList.applications = [];
                    newList.applications.push(item);
                    this.removeToListContact(i.Applications.items, item);
                    children.forEach(element => {
                        this.changeStateBots(element, true);
                        newList.applications.push(element);
                        this.removeToListContact(i.Applications.items, element);
                    });
                    i.ListApplicationsAccount.itemsInHeader.push(newList);
                    i.ListApplicationsAccount.indexList = newList.applications.length;
                }
            });
        });
    }
    async getChildren(shortName, tenantId) {
        return await this.ApplicationService2.getApplicationsWithChildren(shortName, tenantId);
    }
    removeToListContact(listApplications, contact) {
        const indexToRemove = listApplications.findIndex((application) => contact.shortName === application.shortName);
        if (indexToRemove === -1) {
            if (contact.showApplication === undefined && contact.template === BUILDER) {
                contact.showApplication = false;
            }
        }
        else {
            if (contact.showApplication === undefined) {
                contact.showApplication = true;
            }
            listApplications.splice(indexToRemove, 1);
        }
    }
    changeStateBots(contact, status) {
        contact.checked = status;
        contact.blocked = status;
        contact.disabled = status;
    }
    hideListHistoricInExhibition(index) {
        this.viewHistoricDetail[index] = !this.viewHistoricDetail[index];
    }
    onSearchBots(text) {
        const searchText = foldToASCII(text).toLowerCase();
        this.searchText = text;
        this.noSearchResults = false;
        this.applicationsBuffer = angular.copy(this.applicationsInExhibition);
        if (searchText.length > 2) {
            const searchResults = this.applicationsBuffer.filter((x) => foldToASCII(x.name)
                .toLowerCase()
                .includes(searchText));
            const tenant = this.ContextProcessorService.tenant;
            if (tenant && tenant.id) {
                this.SegmentService.createTrack(ORGANIZATION_CHATBOTS_SEARCH, {
                    status: 'success',
                    organizationName: tenant.name,
                    organizationUrl: this.TenantService.getTenantUrl(tenant.id),
                    text: searchText,
                    qtdItens: searchResults.length,
                });
            }
            if (searchResults.length > 0) {
                this.applicationsInExhibition = searchResults;
                this.searchResults = undefined;
            }
            else {
                this.applicationsInExhibition = [];
                this.noSearchResults = true;
            }
        }
        else {
            this.searchText = undefined;
        }
        this.applicationsBuffer = undefined;
    }
};
HistoricMovedApplicationComponent.$inject = ['$state', '$rootScope', '$translate', '$window', '$location', 'ContextProcessorService', 'ApplicationService2', 'TenantService', 'AccountService2', 'LoadingService', 'SegmentService', 'BLIP_DOMAIN'];
HistoricMovedApplicationComponent = __decorate([
    Component({
        template,
        bindings: {
            historic: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof IStateService !== "undefined" && IStateService) === "function" ? _a : Object, typeof (_b = typeof IRootScopeService !== "undefined" && IRootScopeService) === "function" ? _b : Object, typeof (_c = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _c : Object, typeof (_d = typeof Window !== "undefined" && Window) === "function" ? _d : Object, typeof (_e = typeof angular !== "undefined" && angular.ILocationService) === "function" ? _e : Object, typeof (_f = typeof ContextProcessorService !== "undefined" && ContextProcessorService) === "function" ? _f : Object, typeof (_g = typeof ApplicationService2 !== "undefined" && ApplicationService2) === "function" ? _g : Object, typeof (_h = typeof TenantService !== "undefined" && TenantService) === "function" ? _h : Object, typeof (_j = typeof AccountService2 !== "undefined" && AccountService2) === "function" ? _j : Object, typeof (_k = typeof LoadingService !== "undefined" && LoadingService) === "function" ? _k : Object, typeof (_l = typeof SegmentService !== "undefined" && SegmentService) === "function" ? _l : Object, String])
], HistoricMovedApplicationComponent);
export { HistoricMovedApplicationComponent };
